import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import React, { useCallback, useEffect, useContext, useRef } from 'react';
import { useMobxStores } from '@stores/store';
import MainModal from '@app/components/molecules/modal/MainModal';
import { GFH_ENV, isIE, isMobileWithOutIpad } from '@helpers/EnvHelper';
import { isEmpty as _isEmpty } from 'lodash';

import { Context } from '@router/Sound';
import NoSSR from '@molecules/NoSSR';
import MobileMain from '@organisms/main/mobile/MobileMain';
import Main from '@organisms/main/Main';
import CommonMediaDialog from '@molecules/modal/dialog/CommonMediaDialog';
import { useLocation, useNavigate } from 'react-router-dom';

const MainPage = () => {
  const { mainStore, devlogStore, communityStore } = useMobxStores();
  const { i18n } = useTranslation();
  const { setBgmCode } = useContext(Context);

  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const qaVal = queryParams.get('timestamp');
  const isIntro = sessionStorage.getItem('isIntro');

  // 2주년 이벤트 임시 코드
  useEffect(() => {
    if (navigator.userAgent !== 'ReactSnap') {
      {
        /* qa환경에서는 시간을 자동으로 조정할 수 있게 하기위해 추가 */
      }
      const CURRENT_TIME =
        qaVal && (GFH_ENV === 'qa' || GFH_ENV === 'local')
          ? qaVal
          : new Date().getTime();
      const END_TIME_01 = new Date('2024-06-11T09:59:59+09:00').getTime();
      const END_TIME_02 = new Date('2024-07-09T09:59:59+09:00').getTime();

      let checkEndTime = 0;
      let goPage = '';

      if (CURRENT_TIME < END_TIME_01) {
        checkEndTime = END_TIME_01;
        goPage = '2nd_anniversary_teaser';
      } else {
        checkEndTime = END_TIME_02;
        goPage = '2nd_anniversary';
      }

      if (isIntro !== 'on') {
        if (Number(CURRENT_TIME) < Number(checkEndTime)) {
          navigate(`/${i18n.language}/events/${goPage}`);
        }
        sessionStorage.setItem('isIntro', 'on');
      }
    }
  }, []);

  const closeModalType = (isChecked, idx) => {
    if (isChecked) {
      let expires = new Date();
      expires = expires.setHours(expires.getHours() + 24);
      localStorage.setItem('NO_SHOW_TODAY_' + idx, expires);
    }
  };

  const getInitialData = useCallback(async () => {
    await mainStore.getKeyvisual(i18n.language);

    if (!isIE()) {
      await mainStore.getPopup(i18n.language);
    }

    return true;
  }, [mainStore, devlogStore, communityStore, i18n.language]);

  useEffect(() => {
    setBgmCode('');
    getInitialData();
  }, [getInitialData]);

  let isFirstPopup = true;

  return (
    <div className="min-h-screen">
      <NoSSR>
        {!_isEmpty(mainStore.popupList) &&
          mainStore.popupList.contents.map((row, index) => {
            if (row.isShow && (row.type === 'text' || row.type === 'image')) {
              return (
                <MainModal
                  key={`mainmodal_${index}`}
                  onClose={closeModalType}
                  timeClose={true}
                  bgOpacity={isFirstPopup === true ? 70 : 0}
                  left={(index - 1) * 30}
                  idx={row.boardIdx}
                  content={row}
                >
                  {(isFirstPopup = false)}
                </MainModal>
              );
            }
          })}

        {isMobileWithOutIpad() && <MobileMain />}
        {!isMobileWithOutIpad() && <Main />}

        <CommonMediaDialog type={'video'} />
      </NoSSR>
    </div>
  );
};

export default observer(MainPage);
